<template>
  <div>
    <Nav />
    <!-- 主要内容区 -->
    <div class="flex pt-20 max-w-7xl mx-auto">
      <LeftNav activeItem="invoices" />
      <main class="flex-1 p-6">
        <div class="max-w-6xl">
          <div class="flex items-center justify-between mb-8">
            <div>
              <h1 class="text-2xl font-bold text-gray-900">发票管理</h1>
              <p class="text-gray-600 mt-1">
                查看和管理您的发票信息，支持在线申请和下载
              </p>
            </div>
            <button
              class="bg-primary text-white px-6 py-2 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap text-sm"
              @click="goToAddInvoice"
            >
              <i class="ri-add-line mr-2"></i>
              申请发票
            </button>
          </div>
          <div class="grid grid-cols-4 gap-6 mb-8">
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 p-6"
            >
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">全部发票</p>
                  <p class="text-2xl font-bold text-gray-900 mt-1">28</p>
                </div>
                <div
                  class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center"
                >
                  <i class="ri-file-list-line text-blue-600 text-xl"></i>
                </div>
              </div>
            </div>
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 p-6"
            >
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">已开具</p>
                  <p class="text-2xl font-bold text-green-600 mt-1">24</p>
                </div>
                <div
                  class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center"
                >
                  <i class="ri-check-line text-green-600 text-xl"></i>
                </div>
              </div>
            </div>
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 p-6"
            >
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">处理中</p>
                  <p class="text-2xl font-bold text-orange-600 mt-1">3</p>
                </div>
                <div
                  class="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center"
                >
                  <i class="ri-time-line text-orange-600 text-xl"></i>
                </div>
              </div>
            </div>
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 p-6"
            >
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">已拒绝</p>
                  <p class="text-2xl font-bold text-red-600 mt-1">1</p>
                </div>
                <div
                  class="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center"
                >
                  <i class="ri-close-line text-red-600 text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bg-white rounded-xl shadow-sm border border-gray-100 mb-6"
          >
            <div class="p-6 border-b border-gray-100">
              <div
                class="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4"
              >
                <div class="flex-1">
                  <div class="relative">
                    <input
                      type="text"
                      v-model="searchParams.orderNumber"
                      placeholder="请输入订单号搜索"
                      class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                    />
                    <div
                      class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 flex items-center justify-center"
                    >
                      <i class="ri-search-line text-gray-400"></i>
                    </div>
                  </div>
                </div>
                <div class="relative">
                  <el-select
                    v-model="searchParams.status"
                    placeholder="选择状态"
                    class="min-w-32"
                  >
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="已开具" value="已开具"></el-option>
                    <el-option label="处理中" value="处理中"></el-option>
                    <el-option label="已拒绝" value="已拒绝"></el-option>
                  </el-select>
                </div>
                <button
                  class="bg-primary text-white px-6 py-2 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap text-sm"
                  @click="searchInvoices"
                >
                  <i class="ri-search-line mr-2"></i>
                  搜索
                </button>
                <button
                  class="border border-gray-300 text-gray-700 px-6 py-2 rounded-lg hover:border-primary focus:ring-2 focus:ring-primary focus:border-transparent whitespace-nowrap text-sm"
                  @click="resetSearch"
                >
                  <i class="ri-refresh-line mr-2"></i>
                  重置
                </button>
              </div>
            </div>
            <div class="overflow-x-auto">
              <table class="w-full">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      订单信息
                    </th>
                    <th
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      发票类型
                    </th>
                    <th
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      发票金额
                    </th>
                    <th
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      申请时间
                    </th>
                    <th
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      状态
                    </th>
                    <th
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      操作
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <template v-if="invoiceList.length > 0">
                    <tr v-for="invoice in invoiceList" :key="invoice.id">
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div>
                          <div class="text-sm font-medium text-gray-900">
                            {{ invoice.order_number }}
                          </div>
                          <div class="text-sm text-gray-500">
                            {{ invoice.activity_name || "暂无活动名称" }}
                          </div>
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <span class="text-sm text-gray-900">{{
                          invoice.invoice_type
                        }}</span>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <span class="text-sm font-medium text-gray-900"
                          >¥{{
                            formatAmount(invoice.invoice_amount || 0)
                          }}</span
                        >
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <span class="text-sm text-gray-500">{{
                          $tool.formatDate(
                            invoice.createtime,
                            "YYYY-MM-DD HH:mm:ss"
                          )
                        }}</span>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <span
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                          :class="getStatusClass(invoice.status)"
                        >
                          {{ invoice.status || "未知" }}
                        </span>
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2"
                      >
                        <button
                          class="text-primary hover:text-secondary"
                          :disabled="invoice.status !== '已开具'"
                          :class="{
                            'text-gray-400 cursor-not-allowed':
                              invoice.status !== '已开具',
                          }"
                          @click="downloadInvoice(invoice.id)"
                        >
                          下载
                        </button>
                        <button
                          class="text-gray-600 hover:text-gray-900"
                          @click="viewInvoiceDetail(invoice.id)"
                        >
                          详情
                        </button>
                        <button
                          class="text-red-500 hover:text-red-700"
                          :disabled="invoice.status !== '处理中'"
                          :class="{
                            'text-gray-400 cursor-not-allowed':
                              invoice.status !== '处理中',
                          }"
                          @click="cancelInvoice(invoice.id)"
                        >
                          取消
                        </button>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="6" class="px-6 py-8 text-center">
                        <div class="flex flex-col items-center justify-center">
                          <i
                            class="ri-file-search-line text-gray-300 text-4xl mb-4"
                          ></i>
                          <p class="text-gray-500">暂无发票记录</p>
                          <button
                            class="mt-4 text-primary hover:text-secondary"
                            @click="goToAddInvoice"
                          >
                            立即申请发票
                          </button>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <!-- 分页控件 -->
            <Pagination
              v-if="totalCount > 0"
              :totalCount="totalCount"
              :page_current="page_current"
              :page_size="page_size"
              @page-change="handlePageChange"
            />
          </div>
          <div class="bg-blue-50 rounded-xl p-6 border border-blue-100 mt-8">
            <div class="flex items-start space-x-4">
              <div
                class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center"
              >
                <i class="ri-information-line text-blue-600 text-xl"></i>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                  发票开具说明
                </h3>
                <ul class="space-y-2 text-sm text-gray-600">
                  <li class="flex items-start">
                    <div
                      class="w-1 h-1 bg-gray-400 rounded-full mt-2 mr-2 flex-shrink-0"
                    ></div>
                    <span
                      >发票申请提交后，我们将在 3-5
                      个工作日内完成开具，请耐心等待</span
                    >
                  </li>
                  <li class="flex items-start">
                    <div
                      class="w-1 h-1 bg-gray-400 rounded-full mt-2 mr-2 flex-shrink-0"
                    ></div>
                    <span
                      >增值税专用发票需要提供完整的企业资质信息，请确保信息准确无误</span
                    >
                  </li>
                  <li class="flex items-start">
                    <div
                      class="w-1 h-1 bg-gray-400 rounded-full mt-2 mr-2 flex-shrink-0"
                    ></div>
                    <span
                      >发票开具后支持在线下载 PDF
                      格式，如需纸质发票请联系客服</span
                    >
                  </li>
                  <li class="flex items-start">
                    <div
                      class="w-1 h-1 bg-gray-400 rounded-full mt-2 mr-2 flex-shrink-0"
                    ></div>
                    <span
                      >如发票信息有误或需要重开，请在开具后 30
                      天内联系客服处理</span
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <!-- 页脚 -->
    <Footer />

    <!-- 发票详情对话框 -->
    <el-dialog
      title="发票详情"
      :visible.sync="dialogVisible"
      width="600px"
      center
    >
      <div v-if="currentInvoice" class="invoice-detail-content">
        <div class="mb-4 pb-4 border-b">
          <h3 class="text-lg font-medium text-gray-900 mb-3">基本信息</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex justify-between">
              <span class="text-gray-500">订单号：</span>
              <span class="font-medium">{{ currentInvoice.order_number }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">活动名称：</span>
              <span>{{ currentInvoice.activity_name || '暂无活动名称' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">发票类型：</span>
              <span>{{ currentInvoice.invoice_type }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">发票金额：</span>
              <span class="font-medium text-primary">¥{{ formatAmount(currentInvoice.invoice_amount || 0) }}</span>
            </div>
          </div>
        </div>

        <div class="mb-4 pb-4 border-b">
          <h3 class="text-lg font-medium text-gray-900 mb-3">申请信息</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex justify-between">
              <span class="text-gray-500">申请时间：</span>
              <span>{{ $tool.formatDate(currentInvoice.createtime, "YYYY-MM-DD HH:mm:ss") }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">申请人：</span>
              <span>{{ currentInvoice.apply_name || '未知' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">联系电话：</span>
              <span>{{ currentInvoice.contact_phone || '未知' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">申请备注：</span>
              <span>{{ currentInvoice.remark || '无' }}</span>
            </div>
          </div>
        </div>

        <div class="mb-4 pb-4 border-b">
          <h3 class="text-lg font-medium text-gray-900 mb-3">发票信息</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex justify-between">
              <span class="text-gray-500">发票抬头：</span>
              <span>{{ currentInvoice.title || '未知' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">税号：</span>
              <span>{{ currentInvoice.tax_number || '未知' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">地址：</span>
              <span>{{ currentInvoice.address || '未知' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">电话：</span>
              <span>{{ currentInvoice.tax_phone || '未知' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">开户行：</span>
              <span>{{ currentInvoice.bank || '未知' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">银行账号：</span>
              <span>{{ currentInvoice.bank_account || '未知' }}</span>
            </div>
          </div>
        </div>

        <div>
          <h3 class="text-lg font-medium text-gray-900 mb-3">处理信息</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex justify-between">
              <span class="text-gray-500">状态：</span>
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                :class="getStatusClass(currentInvoice.status)"
              >
                {{ currentInvoice.status || '未知' }}
              </span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">处理时间：</span>
              <span>{{ currentInvoice.process_time ? $tool.formatDate(currentInvoice.process_time, "YYYY-MM-DD HH:mm:ss") : '未处理' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">处理人：</span>
              <span>{{ currentInvoice.processor || '未处理' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">拒绝原因：</span>
              <span>{{ currentInvoice.reject_reason || '无' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="text-center py-8">
        <i class="ri-file-search-line text-gray-300 text-4xl mb-4"></i>
        <p class="text-gray-500">发票信息加载中...</p>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/api.js";
import Nav from "@/components/Nav.vue";
import { Message } from "element-ui";
import Footer from "@/components/Footer.vue";
import LeftNav from "@/components/LeftNav.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Invoices",
  components: {
    Nav,
    Footer,
    LeftNav,
    Pagination,
  },
  data() {
    return {
      invoiceList: [],
      searchParams: {
        orderNumber: "",
        status: "",
      },
      page_current: 1,
      page_size: 8,
      totalCount: 0,
      dialogVisible: false, // 控制详情对话框显示
      currentInvoice: null, // 当前查看的发票详情
    };
  },
  computed: {},
  mounted() {
    this.loadInvoiceList();
  },
  methods: {
    // 加载发票列表
    async loadInvoiceList() {
      try {
        const params = {
          ...this.searchParams,
          page_current: this.page_current,
          page_size: this.page_size,
        };
        const response = await api.invoice.getInvoiceList(params);

        this.invoiceList = response.data.resdata || [];
        this.totalCount = response.data.restotal || 0;

        // 遍历发票列表，根据状态转换为中文
        this.invoiceList.forEach((item, index) => {
          switch (item.status) {
            case 1:
              this.invoiceList[index].status = "已开具";
              break;
            case 2:
              this.invoiceList[index].status = "待处理";
              break;
            case 3:
              this.invoiceList[index].status = "处理中";
              break;
            case -1:
              this.invoiceList[index].status = "已拒绝";
              break;
          }
        });
      } catch (error) {
        console.error("加载发票列表失败:", error);
      }
    },

    // 搜索发票
    searchInvoices() {
      this.currentPage = 1;
      this.loadInvoiceList();
    },

    // 重置搜索
    resetSearch() {
      this.searchParams = {
        orderNumber: "",
        status: "",
      };
      this.currentPage = 1;
      this.loadInvoiceList();
    },

    // 处理页码变化
    handlePageChange(page) {
      this.page_current = page;
      this.loadInvoiceList();
    },

    // 格式化金额
    formatAmount(amount) {
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // 获取状态对应的样式类
    getStatusClass(status) {
      switch (status) {
        case "已开具":
          return "bg-green-100 text-green-800";
        case "处理中":
          return "bg-orange-100 text-orange-800";
        case "已拒绝":
          return "bg-red-100 text-red-800";
        default:
          return "bg-gray-100 text-gray-800";
      }
    },

    // 下载发票
    async downloadInvoice(invoiceId) {
      try {
        const response = await api.invoice.downloadInvoice({ id: invoiceId });
        if (response.code === 200) {
          // 实际项目中根据返回的下载链接或文件流进行下载
          Message.success("发票下载链接已生成");
          window.open(response.data.downloadUrl);
        } else {
          Message.error(response.message || "下载失败");
        }
      } catch (error) {
        console.error("下载发票失败:", error);
        Message.error("下载失败，请稍后重试");
      }
    },

    // 查看发票详情
    async viewInvoiceDetail(invoiceId) {
      try {
        const response = await api.invoice.getInvoiceDetail({ id: invoiceId });
        if (response.code === 200) {
          // 获取详情数据并处理状态显示
          this.currentInvoice = response.data || {};
          // 处理状态显示
          if (typeof this.currentInvoice.status === 'number') {
            switch (this.currentInvoice.status) {
              case 1:
                this.currentInvoice.status = "已开具";
                break;
              case 2:
                this.currentInvoice.status = "待处理";
                break;
              case 3:
                this.currentInvoice.status = "处理中";
                break;
              case -1:
                this.currentInvoice.status = "已拒绝";
                break;
            }
          }
          // 打开对话框
          this.dialogVisible = true;
        } else {
          // 如果接口调用失败，尝试从列表中查找
          const invoice = this.invoiceList.find(item => item.id === invoiceId);
          if (invoice) {
            this.currentInvoice = { ...invoice };
            this.dialogVisible = true;
          } else {
            Message.error(response.message || "获取发票详情失败");
          }
        }
      } catch (error) {
        console.error("获取发票详情失败:", error);
        // 错误时尝试从列表中查找
        const invoice = this.invoiceList.find(item => item.id === invoiceId);
        if (invoice) {
          this.currentInvoice = { ...invoice };
          this.dialogVisible = true;
        } else {
          Message.error("获取详情失败，请稍后重试");
        }
      }
    },

    // 取消发票
    async cancelInvoice(invoiceId) {
      this.$confirm("确定要取消该发票申请吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const response = await api.invoice.updateInvoiceStatus({
              id: invoiceId,
              field: "status",
              value: "-1",
            });
            if (response.code === 200) {
              this.loadInvoiceList();
            }
          } catch (error) {
            console.error("取消发票失败:", error);
          }
        })
        .catch(() => {
          // 取消操作
        });
    },

    // 跳转到添加发票页面
    goToAddInvoice() {
      this.$router.push("/invoiceadd");
    },
  },
};
</script>

<style scoped>
.form-input {
  width: 250px;
  height: 36px;
}

.invoice-detail-content {
  font-size: 14px;
}

.invoice-detail-content h3 {
  font-weight: 500;
}

.invoice-detail-content .grid {
  display: grid;
}

.invoice-detail-content .flex {
  display: flex;
}

.invoice-detail-content .justify-between {
  justify-content: space-between;
}

.invoice-detail-content .text-primary {
  color: #1890ff;
}

.invoice-detail-content .font-medium {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/Invoices.vue